import Serializer from 'umg-ember-backend/serializers/application';

export default class ShortUrlTargetSerializer extends Serializer {
  attrs = {
    position: 'cmsPosition',
  };
}
